// extracted by mini-css-extract-plugin
export default {"wrap":"Sticky_wrap__UbWfb","container":"Sticky_container__2jFQs","mobile":"Sticky_mobile__gzWIc"};